import * as Yup from "yup";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";


export const useGenerateLinkSchema = () => {
  const { t } = useTranslation();
  return useMemo(
    () =>
      Yup.object({
        name: Yup.string().trim()
          .required(t("validationNameRequired"))
          .min(1, t("validationNameMinLength"))
      }),
    [t]
  );
};


export const TYPE = {
  ASKING_QUESTION: "askingQuestion",
  RECEIVING_QUESTION: "receivingQuetion",
  STATEMENT_MAKE: 'makeStatement',
  STATEMENT_RECEIVED: 'receiveStatement',
}



export const FEELING_OTPIONS = {
  SELF: [{ id: 1, name: 'Preety good ' }, { id: 2, name: 'Neutral ' }],
  OTHER: [{ id: 1, name: 'Preety good' }, { id: 2, name: 'Unhappy' }]
}

export const SOCKET_EVENT_TYPE = {
  //room is session
  //room
  CREATED_SESSION: "roomCreated",
  ROOM_JOINED: "roomJoined",
  USER_JOINED: "userJoined",
  READY_TO_JOIN: "readyToJoin",

  JOIN_AND_READY: "joinedAndReady",
  READY_TO_DISCUSS: "ReadyToDiscuss",
  FINAL_JOIN: "finalJoin",
  //session
  //close session emitter
  CONFIRM_CLOSE_SESSION: "confirmCloseSession",
  CLOSE_SESSION: "closeSession",
  //close session listener
  //aksing modal confirmation
  CLOSE_SESSION_SENDER_RESPONSE: "closeSessionEventTrigger",
  CLOSE_SESSION_RECEIVER_RESPONSE: "closeSessionEventResponse",
  //confirm modal listens
  FINAL_CLOSE_SENDER: "finalCloseSender",
  FINAL_CLOSE_RECEIVER: "finalCloseReceiver",
  //close session listener
  //question
  QUESTION_ASKED_FINISH: "quetionAskedFinished",
  SUMMARIZE_QUESTION_RESPONSE: "summarizeQuetionResponse",
  QUESTION_SUMMARIZED_FINISH: "quetionSummarizedFinished",
  FINISH_QUESTION_SUMMARIZED: "finishQuetionSummarized",
  QUESTION_SUMMARIZED_RESPONSE: "questionSummarizedRes",
  SUBMMARIZED_QUESTION_RES: "summarizedQuetionRes",
  FINISH_QUESTION_ASKED: "finishQuetionAsked",
  FINISH_ASKING_QUESTION: "finishAskingQuetion",
  QUESTION_ASKED: "questionAsked",
  ASKING_QUESTION: 'askingQuetion',
  SUMMARIZED_QUESTION_FINISH: 'summarizeQuetionFinish',
  //STATEMENT
  MAKING_STATEMENT: "makingStatement",
  STATEMENT_ASKED: "statementAsked",
  STATEMENT_MADE_FINISHED: "statementMadeFinished",
  SUMMARIZE_STATEMENT_FINISH: "summarizeStatementFinish",
  FINISH_STATEMENT_MADE: "finishStatementMade",
  FINISH_MAKING_STATEMENT: 'finishMakingStatement',
  //after finish statement response for the sender
  FINISH_STATEMENT_SUMMARIZED: 'finishStatementSummarized',
  //after finish statement response for the receiver
  STATEMENT_SUMMARIZED_FINISH: "StatementSummarizedFinished",

  STATEMENT_SUMMARIZE__RESPONSE_EVENT: "statementSummarizeResponseEvent",
  STATEMENT_SUMMARIZED_RESPONSE_SENDER: "summarizedStatementResForSender",
  STATEMENT_SUMMARIZED_RESPONSE_RECEIVER: "summarizedStatementResForReceiver",

  //emotion first screen
  EMOTION_FIRST_SCREEN: "saveFirstScreenEmotion",
  //emotion second screen
  EMOTION_SECOND_SCREEN: "saveSecondScreenEmotion",
  ADD_FEELING_SECOND_SCREEN_SENDER: "addFeelingSecondScreenSender",
  ADD_FEELING_SECOND_SCREEN_RECEIVER: "addFeelingSecondScreenReceiver",
  EMOTION_CONTINUE: "emotionContinue",
  //emitter event
  CONTINUE_AFTER_EMOTION: "continueAfterEmotion",
  //error
  ERROR: "error",
  //answers module
  //emit
  FINISH_ASNSWER: "finishedAsnswer",
  //listener
  FINISH_ANSWER_SENDER: 'finishAnswerSender',
  FINISH_ANSWER_RECEIVER: 'finishAnswerReceiver',
  //listners
  CONTINUE_AFTER_SESSION_CLOASE_LISTENER: 'continueAfterSessionCloseListener',
}


export const USER_CURRENT_PATH = {
  HOME: "/",
  GENERATE_LINK: "/generate-link",
  DISCUSS_INVITE: "/discuss-invite",
  RETURN_AFTER_DOORSTOP: "/return-afterstop",
  ABOUT_US: "/about-us", // Assuming you want to add an "About Us" page; update if needed
  USER_WAITING: "/user-waiting",
  CONTINUE: "/continue",
  USER_ASK: "/user-ask",
  TELL_USER: "/tell-user",
  LISTEN: "/listen",
  EMOTIONS: "/emotions",
  START_AFTER_STOP: "/start-afterstop",
  INFORMAL_STOP: "/informal-stop",
  SAY_SOMETHING: "/say-something",
  SUMMARIZED_QUESTION_FINISH: "/summarizedQuestionFinish",
  SUMMARIZED_ANSWER: "/summarized-answer",
  SUMMARIZED: "/summarized",
  SUMMARIZED_ASK: "/summarized-ask",
  SUMMARIZED_SAID: "/summarized-said",
  SUMMARIZED_QUESTION_ASK: "/summarized-questionask",
  SUMMARIZED_WHAT_SAID: "/summarized-whatsaid",
  ANSWER_QUESTION: "/answer-question",
  LISTEN_ANSWER: '/listen-answer',
  WAIT_TO_CONTINUE: '/wait-to-continue',
  CONTINUE_AFTER_FINISH: '/please-wait',
  CONTINUE_AFTER_FINISH_ASNWER: '/please-wait-answer',
  ANSWER_SUMMARIZE_LISTEN: '/answer-summarize-listen',
  ANSWER_SUMMARIZE_SAID: '/answer-summarize-said',
  CONTACT_US: '/contact-us',
  LEGAL_STUFF: '/legal',
  CREDIT: '/credit',
  SETTING:'/setting'
};


